export interface FlightTypeIconMeta {
  label: string;
  icon: "site" | "hike" | "tandem";
}

export function getFlightTypeIconMeta(type: string): FlightTypeIconMeta {
  if (type === "hike and fly") {
    return {
      label: "Hike and fly",
      icon: "hike",
    };
  }

  if (type === "tandem") {
    return {
      label: "Tandem",
      icon: "tandem",
    };
  }

  if (type === "site flight") {
    return {
      label: "Site flight",
      icon: "site",
    };
  }

  return {
    label: "Flight",
    icon: "site",
  };
}
